<template>
	<div>
		<v-content>
			<v-container fluid>           
              <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="vehiclesLoaded == false" /></center>
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field v-if="vehiclesLoaded == true && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" v-if="vehiclesLoaded == true && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>                
              </v-flex>		        
				<v-data-table :headers="headers" v-if="vehiclesLoaded == true" :search="search" id="hello" :items="vehicleList" class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
						<td width="16%" class="text-xs-right">{{ props.item.name }}</td>      
						<td width="10%" class="text-xs-right">{{ props.item.reg_no }}</td>
                        <td width="22%" class="text-xs-right">{{ props.item.description }}</td>
						<td width="16%" class="text-xs-right">{{ props.item.created }}</td>						
                        <td width="16%" class="text-xs-right">{{ props.item.modified }}</td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1"><a @click.prevent="fncEditVehicle(props.item.id)"><i class="material-icons">edit</i></a></td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1"><a @click.prevent="fncDeleteVehicle(props.item.id)"><i class="material-icons">delete_forever</i></a></td>						
					</template>
				</v-data-table>
			</v-container>
		</v-content> 		
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
			headers: [         
				{ text: 'Name', value: 'name', width: '16%' },
                { text: 'Registration No', value: 'registration_no', width: '10%' },
                { text: 'Description', value: 'description', width: '22%' },
                { text: 'Created On', value: 'created', width: '16%' },
                { text: 'Modified On', value: 'modified', width: '16%' },
                { text: 'Edit', value: 'edit', width: '10%' },	
                { text: 'Delete', value: 'delete', width: '10%' }			
			]
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
      },
      fncEditVehicle(vehicleId ) {		
			this.$store.commit({
				type: 'setObjVehicleEdit',
                id: vehicleId
            });
            this.$store.dispatch('setObjVehicleEdit')
            var modalDetails = { title: 'Edit Vehicle', component: 'modal-vehicle-edit', mstate: true, params: { vehicleId: vehicleId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
      fncDeleteVehicle(vehicleId ) {
		  var deleteConfirm = confirm('Are you sure you want to remove this vehicle?');
		  if(deleteConfirm === true) {
			  this.$store.dispatch({
				  type: 'fncDeleteVehicle',
                  vehicleId: vehicleId
			  })
		  }
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'vehicleList',
            'globalModalParams',
            'vehiclesLoaded'
		])
	},
	beforeMount() {
        this.$store.dispatch('fncPopulateVehicles');		
	},
	created() {		
	}
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>